module.exports = __webpack_public_path__ + "static/media/grass_fed_beef.3b62f948.svg";